import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Allergy icon - Letter "A"
 * Used to indicate patient has allergies on file.
 * Similar to industry standard (Kipu, etc.)
 */
@Component({
  selector: 'ease-allergy-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-w-full tw-h-full">
      <text
        x="12"
        y="18"
        text-anchor="middle"
        font-size="20"
        font-weight="700"
        font-family="system-ui, sans-serif"
        fill="currentColor"
      >
        A
      </text>
    </svg>
  `,
  host: {
    class: 'tw-block tw-w-full tw-h-full',
  },
})
export class AllergyIcon {}
